import axios from 'axios';
import { useUsers } from '@/features/users/controller';
import router from '@/router';

// paramétrage pour SPA et CRSF Token
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

// paramétrage de Axios
const apiService = axios.create({
    // base url du back contenu dans un fichier .env
    baseURL: import.meta.env.VITE_BASE_URL_API + '/api',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    validateStatus: (status) => {
        return status < 300 || status === 422;
    }
});

// Interceptor pour ajouter le token d'authentification
apiService.interceptors.request.use(
    function (config) {
        const $userStore = useUsers();
        const token = $userStore.userToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


// interception des erreurs
apiService.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        if (error.response) {
            const originalRequest = error.config;
            let $userStore = useUsers();
            switch (error.response.status) {
                case 401:
                    // on vide l'user connecté
                    $userStore.loggedUser = null;
                    $userStore.userToken = null;
                    // redirection
                    router.push({ name: 'login' });
                    // window.location.href = '/connexion'; 
                    break;
                case 403:
                    // on vide l'user connecté
                    $userStore.loggedUser = null;
                    $userStore.userToken = null;
                    // redirection
                    router.push({ name: 'login' });
                    // window.location.href = '/connexion'; 
                    break;
                // case 419:
                //     // retry en cas de 419
                //     if (!originalRequest._retry) {
                //         originalRequest._retry = true;
                //         await getCsrfCookie();
                //         return axios(originalRequest);
                //     }
                default:
                    break;
            }
        }
        return error;
    }
);

// interception des réponses
async function handleResponse(response: any) {
    // si "bonne r"ponse
    if (response.status && response.status.toString().match(/^2[0-9]{2}/)) {
        return {
            error: false,
            data: response.data
        };
    }

    // si "mauvaise" réponse (error)
    return {
        error: true,
        data: response.data ?? response.response?.data,
        errors: response?.data?.errors ?? response.response?.data?.errors,
    };
}

// fonction pour récupérer csrf cookie de sanctum, le cookie sera ensuite ajouté dans les prochaines requêtes
// async function getCsrfCookie() {
//     const response = await apiService.get(`/sanctum/csrf-cookie`, { baseURL: import.meta.env.VITE_BASE_URL_API });
//     return handleResponse(response);
// }

// Mise à disposition de Axios et de la fonction handleResponse
export { apiService, handleResponse };